import { z } from 'zod';
import { dbEntityUpdateSchema } from './db-entity';
import { entitySchema } from './entity';

export type UpdateEntityParams = {
  entityId: string;
  body: UpdateEntityRequest;
};

export const updateEntityRequestSchema = z.object({
  entity: dbEntityUpdateSchema,
});

export type UpdateEntityRequest = z.infer<typeof updateEntityRequestSchema>;

export const updateEntityResponseSchema = entitySchema;

export type UpdateEntityResponse = z.infer<typeof updateEntityResponseSchema>;
